import { getPaginationLimit } from 'SharedPartialsLocal/getPaginationLimit';
import Author from './ComposedAuthor';
import { AuthorQuery } from './AuthorQuery.graphql';

Author.query = AuthorQuery;
Author.queryVars = getPaginationLimit;

export default Author;
